import { render, staticRenderFns } from "./Cessation.vue?vue&type=template&id=dbbb8ee0"
import script from "./Cessation.vue?vue&type=script&lang=js"
export * from "./Cessation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports